<template>
  <div>
    <a :href="item.Url" class="info-card info-card--full-height">
      <div class="info-card__image-frame">
        <picture class="c-image-frame c-image-frame--border-radius-at-medium" :class="imageModifier" v-if="item.Image">
          <source v-if="item.Image.Crops['1:1 Aspect Ratio Crop']" width="1200" height="1200" :data-srcset="item.Image.Crops['1:1 Aspect Ratio Crop'].SrcSet" media="(max-width: 959px)">
          <img width="1200" height="750" class="c-image-frame__image lazyload" data-sizes="auto" alt="" :data-srcset="item.Image.Crops['16:10 Aspect Ratio Crop'].SrcSet" :data-src="item.Image.Crops['16:10 Aspect Ratio Crop'].Src">
        </picture>
      </div>
      <div class="info-card__content" :class="contentModifier">
        <div class="info-card__heading" :class="headingModifier">
          <span>{{ item.Name }}</span>
          <span class="info-card__arrow" v-if="showArrows">
            <svg xmlns="http://www.w3.org/2000/svg" width="25px" height="15px" viewBox="0 0 56 31.617">
              <path d="M0 15.798a2.25 2.25 0 002.23 2.27h46.19L39 27.738a2.29 2.29 0 000 3.21 2.19 2.19 0 003.15 0l13.21-13.54a2.345 2.345 0 000-3.22L42.15.668a2.19 2.19 0 00-3.15 0 2.29 2.29 0 000 3.21l9.43 9.68H2.23A2.25 2.25 0 000 15.798z" />
            </svg>
          </span>
        </div>
        <div class="info-card__description" v-if="item.Description">
          {{ item.Description }}
        </div>
        <div class="info-card__tag" v-if="!hideTags">
          <template v-if="intersectedTags">
            {{ intersectedTags.slice(0, 3).join(', ') }}
            <template v-if="intersectedTags.length > 3">...</template>
          </template>
          <template v-else-if="item.PrimaryTag">
            {{ item.PrimaryTag.Name }}
          </template>
        </div>
      </div>
    </a>
  </div>
</template>
<script>
export default {
    props: {
        item: {
            type: Object,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        defaultSelectedTags: {
            type: Array,
            default: () => []
        },
        hideTags: {
            type: String,
            required: false,
            default: ''
        },
        hierarchicalHeadings: {
            type: Boolean,
            required: false
        },
        showArrows: {
            type: Boolean,
            required: false
        },
        showAngledImage: {
            type: Boolean,
            required: false
        }
    },
    computed: {
        headingModifier() {
            let heading = ''
            if(this.hierarchicalHeadings) {
                if(this.index === 0 | this.index === 1) {
                    heading = 'info-card__heading--large'
                }
                if(this.index === 2 | this.index === 3| this.index === 4) {
                    heading = 'info-card__heading--small'
                }
            }
            if(this.showArrows) {
                heading += ' info-card__heading--flex'
            }
            return heading
        },
        intersectedTags() {
            if(this.defaultSelectedTags && this.defaultSelectedTags.length && this.item.Tags.length) {
                const tagList = this.item.Tags.map(x => x.Name)
                const intersection = this.defaultSelectedTags.filter(element => tagList.includes(element))
                return intersection
            }
            return ''
        },
        imageModifier() {
            if(this.showAngledImage) {
                return 'c-image-frame--angled'
            }
            return ''
        },
        contentModifier() {
            if(this.showAngledImage) {
                return 'info-card__content--remove-padding-top'
            }
            return ''
        }
    }
}
</script>